(function () {
  // Skip entirely for reduced-motion users and while editing in the theme editor,
  // where sections re-render on every settings change and a fade-in would just be noise.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify?.designMode) return;

  const sections = document.querySelectorAll(
    '#MainContent > .shopify-section:not(:first-of-type), footer > .shopify-section'
  );
  if (!sections.length) return;

  // This theme scrolls inside `.page-wrapper` on desktop (`overflow-y: auto`, from a
  // `min-width: 990px` media query) instead of the window. Whether that's true can change at
  // any time the viewport crosses that breakpoint (resizing a window, rotating a tablet), so
  // it's re-checked on resize below rather than decided once at load.
  const pageWrapper = document.querySelector('.page-wrapper');

  function isPageWrapperScrollable() {
    return !!pageWrapper && getComputedStyle(pageWrapper).overflowY === 'auto';
  }

  function viewportHeight() {
    return isPageWrapperScrollable() ? pageWrapper.clientHeight : window.innerHeight;
  }

  const pending = new Set();

  for (const section of sections) {
    const rect = section.getBoundingClientRect();
    // Skip anything whose top edge isn't below the viewport - that covers sections
    // currently on screen (hero, LCP candidates - shouldn't fade in) AND sections the
    // user has already scrolled past by the time this script runs (it loads at low
    // priority, so a fast scroller can outrun it - those must not be hidden, or they'd
    // never get a further scroll event to reveal them again).
    if (rect.top < viewportHeight()) continue;

    section.classList.add('scroll-animate');
    pending.add(section);
  }

  if (!pending.size) return;

  let scrollTarget = null;
  let ticking = false;

  function revealVisible() {
    ticking = false;
    const vh = viewportHeight();

    for (const section of pending) {
      const rect = section.getBoundingClientRect();
      if (rect.top >= vh || rect.bottom <= 0) continue;

      section.classList.add('scroll-animate--visible');
      pending.delete(section);
    }

    if (!pending.size) detachScroll();
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(revealVisible);
  }

  function detachScroll() {
    if (scrollTarget) scrollTarget.removeEventListener('scroll', onScroll);
    scrollTarget = null;
  }

  // Attaches the scroll listener to whichever element actually scrolls right now, moving it
  // if that has changed since the last check (e.g. a resize just crossed the 990px breakpoint).
  // Without this, a listener left on the old element goes silent and stranded sections never
  // get another chance to reveal.
  function syncScrollTarget() {
    const target = isPageWrapperScrollable() ? pageWrapper : window;
    if (target === scrollTarget) return;
    detachScroll();
    scrollTarget = target;
    scrollTarget.addEventListener('scroll', onScroll, { passive: true });
  }

  syncScrollTarget();

  let resizeTicking = false;
  window.addEventListener(
    'resize',
    () => {
      if (resizeTicking || !pending.size) return;
      resizeTicking = true;
      requestAnimationFrame(() => {
        resizeTicking = false;
        if (!pending.size) return;
        syncScrollTarget();
        // The resize itself (not a scroll) may have already brought a section into view.
        revealVisible();
      });
    },
    { passive: true }
  );
})();
